const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const ColorUtil = require("../core/util/ColorUtil");
const PieGraph = require("../core/view/PieGraph");
const {TEST_RANGES} = require("../../shared/TrainerCore");

const styles = require("./styles/ReportMainBody.css");

module.exports = createReactClass({
	displayName: "SummaryCircles",

	propTypes: {
		className: PT.string.isRequired,
		circleClass: PT.string,
		data: PT.array.isRequired,
		dataType: PT.oneOf(["stars", "stars-intervened", "trials", "celestials"]),
		dataTypes: PT.array, // Array of dataTypes corresponding to data
		problemsPerSet: PT.number,
		forTest: PT.bool,
		forBookTest: PT.bool,
	},

	// data is a list of star values -3, -2, -1, 0, 1, 2, 3 (-1 is unplayed, -2 is intervened, -3 is partially complete)
	calculateStars(data, hasIntervened) {
		const total = data.length;
		const sorted = _.groupBy(data, s => parseInt(s));
		let categories = [3, 2, 1, 0, -1];
		const colors = ColorUtil.getBlueStarColors(4);

		if (hasIntervened) {
			categories = [3, 2, 1, 0, -2, -3, -1];
			colors.push(ColorUtil.getCurrentScheme().incorrectFill);
			colors.push(ColorUtil.getCurrentScheme().lighterGrayFill);
		}
		colors.push(ColorUtil.getCurrentScheme().lightGrayFill);

		const starAmts = categories.map((c, i) => {
			const numOfN = _.get(sorted, [c.toString(), "length"], 0);
			return {color: colors[i], percent: numOfN / total};
		});

		return starAmts;
	},
	// data is a list of celestialIDs - 1:  0, 1, 2, 3
	// -1 is not attempted
	calculateCelestials(data) {
		const total = data.length;
		const sorted = _.groupBy(data, s => parseInt(s));
		const categories = [3, 2, 1, 0, -1];
		const colors = ColorUtil.getPurpleCelestialColors(4);

		colors.push(ColorUtil.getCurrentScheme().lightGrayFill);

		const colorAmts = categories.map((c, i) => {
			const numOfN = _.get(sorted, [c.toString(), "length"], 0);
			return {color: colors[i], percent: numOfN / total};
		});

		return colorAmts;
	},

	// data is a list of problems: {outcome, trials, customState, etc.}
	calculateTrials(data, i) {
		const colors = ColorUtil.getCurrentScheme();
		let correct = 0;
		let incorrect = 0;
		let incomplete = 0;
		const total = data.length;
		_.each(data, p => {
			if (p[i]) {
				const outcome = p[i].outcome;
				const trials = p[i].trials ? p[i].trials.length : 0;
				if (trials) {
					if (outcome === "correct") {
						if (trials > 1) {
							correct += 1 / trials;
							incorrect += 1 - 1 / trials;
						} else {
							correct++;
						}
					} else if (outcome === "incorrect") {
						incorrect++;
					} else {
						if (trials > 1) {
							incomplete += 1 / trials;
							incorrect += 1 - 1 / trials;
						} else {
							incomplete++;
						}
					}
				}
			}
		});
		return [
			{color: colors.lightGrayFill, percent: _.round(incomplete / total, 2)},
			{color: colors.correctFill, percent: _.round(correct / total, 2)},
			{color: colors.incorrectFill, percent: _.round(incorrect / total, 2)},
		];
	},

	render() {
		const {
			className,
			data,
			dataType,
			dataTypes,
			problemsPerSet,
			circleClass,
			forTest,
			forBookTest,
		} = this.props;

		let circleData;
		if (dataTypes) {
			circleData = data.map((s, i) => {
				if (dataTypes[i] === "celestials") {
					return this.calculateCelestials(s);
				} else {
					return this.calculateStars(s, dataType === "stars-intervened");
				}
			});
		} else if (dataType === "celestials") {
			circleData = data.map(s => this.calculateCelestials(s));
		} else if (dataType === "stars" || dataType === "stars-intervened") {
			circleData = data.map(s =>
				this.calculateStars(s, dataType === "stars-intervened")
			);
		} else {
			circleData = _.range(problemsPerSet).map(i =>
				this.calculateTrials(data, i)
			);
		}
		const pieEls = circleData.map((cd, i) => {
			if (dataType === "trials" || !circleClass) {
				return (
					<PieGraph className={styles.circle} key={"pie-" + i} data={cd} />
				);
			} else {
				return (
					<div className={circleClass} key={"pie-" + i}>
						<PieGraph className={styles.circle} data={cd} />
					</div>
				);
			}
		});

		if (forBookTest || forTest) {
			// TODO: RKL's changes probably have a better solution to this.
			const range = forBookTest ? [15, 17] : TEST_RANGES[pieEls.length];
			const dot = <div className={styles.dot} key="dot" />;
			pieEls.splice(range[0], 0, dot);
		}

		return <div className={className}>{pieEls}</div>;
	},
});
